function SortingAlphabatically(list) {
  if (list?.length > 0) {
    return list?.sort((a, b) => a?.value?.localeCompare(b.value));
  } else {
    return null;
  }
}

export default SortingAlphabatically;
